// ============================================================
//  src/admin/context/AdminAuthContext.js
// ============================================================
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { adminMe, adminLogin as apiAdminLogin, adminLogout as apiAdminLogout } from '../api/adminClient';

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin]   = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem('aAuthToken');
    if (!token) { setAdmin(null); setLoading(false); return; }
    try {
      const res = await adminMe();
      setAdmin(res.data.admin);
    } catch {
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  async function login(email, password) {
    const res = await apiAdminLogin(email, password);
    localStorage.setItem('aAuthToken', res.data.token);
    localStorage.setItem('aAdmin', JSON.stringify(res.data.admin));
    setAdmin(res.data.admin);
    return res.data;
  }

  async function logout() {
    try { await apiAdminLogout(); } catch { /* ignore */ }
    localStorage.removeItem('aAuthToken');
    localStorage.removeItem('aAdmin');
    setAdmin(null);
  }

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout, refresh }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error('useAdminAuth must be used within AdminAuthProvider');
  return ctx;
}